import React from 'react';
import classNames from 'classnames';
import * as Render from '../../Base/Render';
import Breadcrumb from '../../Breadcrumb';
import Section from '../../Section';
import ArticleHeader from '../../ArticleHeader';
import CollectionPageFooter from '../../CollectionPageFooter';

const CollectionPage = (props) => {
  const introClasses = classNames({
    'medium-8': true,
    'large-offset-0': true,
    'large-7': props.Content.Image,
    'large-8': !props.Content.Image,
    columns: true,
    ...props.Modifiers,
  });

  return (
    <>
      <div className="breadcrumb-container">
        <div className="row">
          <div className="columns">
            <Breadcrumb {...props.Breadcrumbs} Language={props.Language} />
          </div>
        </div>
      </div>
      <main className="main page page--collection-page">
        <div id="content" dir={props.Dir}>
          <Section
            Modifiers={{ 'c-section--first': true, 'c-section--intro': true }}
          >
            <div className="row">
              <div className={introClasses}>
                <ArticleHeader
                  Heading={Render.Property(props.Content.Heading, 'Heading')}
                  HeadingTranslation={props.Content.HeadingTranslation}
                  Preamble={Render.Property(props.Content.Preamble, 'Preamble')}
                  SubjectAboveHeading={true}
                  {...props}
                />
              </div>
              {props.Content.Image && (
                <div className="medium-8 medium-centered large-uncentered large-offset-1 large-4 columns">
                  <Render.Block
                    blocks={props.Content.Image}
                    propertyName="Image"
                    currentPageProps={props}
                    isBackgroundImage={true}
                    UseZoom={false}
                    ShowCaption={false}
                    UseLazyload={false}
                    Modifiers={{
                      'c-imageblock--medium-margin': true,
                      'c-imageblock--is-intro': true,
                    }}
                    Sizes={{
                      sizes: '(min-width: 1024px) 1024px, 800px',
                    }}
                  >
                    {props.BlockTypeRenderer}
                  </Render.Block>
                </div>
              )}
            </div>
          </Section>

          {props.HorizontalAnchorNavigation}

          <Render.Block
            blocks={props.Content.MainContent}
            propertyName="MainContent"
            stylePropertyName="SectionContent"
            currentPageProps={props}
          >
            {props.BlockTypeRenderer}
          </Render.Block>

          {props.Content.CollectionPageFooter && (
            <CollectionPageFooter
              footer={props.Content.CollectionPageFooter}
              translations={props.Content.Translations}
              isRegional={false}
              isLast={
                !!(
                  props.Content.CollectionPageFooter &&
                  !props.Content.RegionalCollectionPageFooterContent
                )
              }
              hasBottomContent={!!props.Content.BottomContent}
            />
          )}

          {props.Content.RegionalCollectionPageFooterContent && (
            <CollectionPageFooter
              footer={props.Content.RegionalCollectionPageFooterContent}
              translations={props.Content.Translations}
              isRegional={true}
              isLast={
                !!(
                  props.Content.CollectionPageFooter &&
                  props.Content.RegionalCollectionPageFooterContent
                ) ||
                (!props.Content.CollectionPageFooter &&
                  props.Content.RegionalCollectionPageFooterContent)
              }
              hasBottomContent={!!props.Content.BottomContent}
            />
          )}

          {props.Content.BottomContent && (
            <Render.Block
              blocks={props.Content.BottomContent}
              propertyName="BottomContent"
              currentPageProps={props}
            >
              {props.BlockTypeRenderer}
            </Render.Block>
          )}
        </div>
      </main>
    </>
  );
};

export default CollectionPage;
